import React, { Fragment, useEffect, useState } from "react";
import { AppBar } from "../ui/app-bar";
import { useRouter } from "expo-router";
import LessonHistoryList from "./lesson-history-list";
import { Text, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import ChildrenTabList from "../shared/children-tab-list";
import { Id } from "@teachloop/backend/_generated/dataModel";
import ParentLessonHistorySubjectList from "./parent-lesson-history-subject-list";
import goBack from "../utils/go-back";

function ParentLessonHistory() {
  const router = useRouter();
  const { data: children = [] } = useQuery(
    convexQuery(api.parent.lessonHistory.queries.getChildren, {})
  );
  const [firstChild] = children;
  const firstChildId = firstChild?._id;
  const [selectedChildId, setSelectedChildId] = useState<Id<"students"> | null>(
    null
  );
  const [selectedSubjectId, setSelectedSubjectId] =
    useState<Id<"subjects"> | null>(null);
  const { data: lessonHistorySubjects = [] } = useQuery(
    convexQuery(
      api.parent.lessonHistory.queries.getSubjects,
      selectedChildId
        ? {
            studentId: selectedChildId,
          }
        : "skip"
    )
  );
  const [firstSubject] = lessonHistorySubjects;
  const firstSubjectId = firstSubject?.id;
  const { data: lessonReports = [] } = useQuery(
    convexQuery(
      api.parent.lessonHistory.queries.getLessonReports,
      selectedChildId && selectedSubjectId
        ? {
            studentId: selectedChildId,
            subjectId: selectedSubjectId,
          }
        : "skip"
    )
  );

  useEffect(() => {
    if (firstChildId && !selectedChildId) {
      setSelectedChildId(firstChildId);
    }
  }, [firstChildId, selectedChildId]);

  useEffect(() => {
    if (firstSubjectId && !selectedSubjectId) {
      setSelectedSubjectId(firstSubjectId);
    }
  }, [firstSubjectId, selectedSubjectId]);

  return (
    <Fragment>
      <AppBar>
        <AppBar.Icon onPress={goBack} />
        <AppBar.Title>Back</AppBar.Title>
      </AppBar>
      <LessonHistoryList
        lessonReports={lessonReports}
        ListHeaderComponent={() => (
          <View className="mx-5">
            <View className="h-2" />
            <View className="gap-1">
              <Text className="text-[28px] text-gray-800 leading-[1.2] font-medium font-zilla-slab-medium">
                Lesson history
              </Text>
              <Text className="text-xl font-geologica-regular font-normal leading-[1.5] text-gray-800">
                View all previous lesson reports here
              </Text>
            </View>
            <View className="h-8" />
            <ChildrenTabList
              childList={children}
              selectedChildId={selectedChildId}
              setSelectedChildId={setSelectedChildId}
            />
            <View className="h-4" />
            <ParentLessonHistorySubjectList
              lessonHistorySubjects={lessonHistorySubjects}
              selectedSubjectId={selectedSubjectId}
              setSelectedSubjectId={setSelectedSubjectId}
            />
            <View className="h-4" />
          </View>
        )}
      />
    </Fragment>
  );
}

export default ParentLessonHistory;
